import { ShieldCheck } from 'lucide-react'
import { Link } from 'react-router-dom'

const Refund = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-secondary-500 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <ShieldCheck className="h-12 w-12 mx-auto mb-4 text-primary-400" />
          <h1 className="text-3xl md:text-5xl font-bold mb-4">Cancellation & Refund Policy</h1>
          <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto">
            Clear and transparent policies for your room bookings at Aonla Stay
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 md:p-12 rounded-xl shadow-sm text-gray-700 space-y-8">
            <p className="text-lg">We understand that plans can change. Please read our cancellation policies carefully before making any booking.</p>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 border-b pb-2">Standard Cancellation</h2>
              <p>You can cancel your booking completely free of charge up to <strong>24 hours before your scheduled arrival date</strong> for a full refund. Please ensure you provide your <strong className="text-gray-900">Booking ID</strong> for all cancellation and refund requests.</p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 border-b pb-2">Non-Refundable Bookings</h2>
              <p>Some special promotional rates or discounted bookings may be strictly non-refundable. These conditions will be clearly stated at the time of booking your room.</p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 border-b pb-2">No-Shows</h2>
              <p>If you fail to arrive on your scheduled check-in date without prior notification (a "no-show"), your entire reservation will be cancelled, and you will be charged the full amount of your booked stay.</p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 border-b pb-2">Processing Refunds</h2>
              <p>All refund requests must include your valid <strong className="text-gray-900">Booking ID</strong>. Approved refunds will be processed back to the original method of payment within 5-7 business days. Please note that your bank or credit card provider may take additional time to reflect the amount on your statement.</p>
            </div>
            
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-3 border-b pb-2">Early Departure</h2>
              <p>If you decide to shorten your stay after checking in, the remaining nights are non-refundable unless specified otherwise by our management.</p>
            </div>
            
            <div className="pt-6">
              <Link to="/rooms" className="inline-block px-8 py-3 bg-primary-500 text-white font-semibold rounded-lg shadow hover:bg-primary-600 transition-colors">
                Book Your Stay With Confidence
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Refund
